import React from 'react';

import './DocRow.scss';

export interface DocRowProps {
    title: string;
    value: string;
    bold?: boolean;
    rowClassName?: string;
    titleClassName?: string;
    valueClassName?: string;
    usePre?: boolean;
}

export const DocRow: React.FC<DocRowProps> = ({
                                                  title,
                                                  value,
                                                  bold,
                                                  rowClassName,
                                                  titleClassName,
                                                  valueClassName,
                                                  usePre = false
                                              }) => (
        <div className={`doc-row ${rowClassName || ''}`}>
            <div className={`doc-row__title ${titleClassName || ''}`}>{title}</div>
            <div className={`doc-row__value ${valueClassName || ''}`}>
                {usePre ? <pre style={{"fontFamily": "inherit"}}>
                              {bold ? <b>{value}</b> : value}
                          </pre>
                        : (bold ? <b>{value}</b> : value)
                }
            </div>
        </div>
);
